export const LUDO_STAKE_PRESETS = [50, 100, 150, 200, 300, 500, 1000, 1500, 2000];

/** Max players shown on dashboard compact panel before "see more" prompt */
export const DASHBOARD_MAX_LUDO_PLAYERS = 12;
